import { render, staticRenderFns } from "./splitRoom.vue?vue&type=template&id=00b2a116&scoped=true"
import script from "./splitRoom.vue?vue&type=script&lang=js"
export * from "./splitRoom.vue?vue&type=script&lang=js"
import style0 from "./splitRoom.vue?vue&type=style&index=0&id=00b2a116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b2a116",
  null
  
)

export default component.exports